import * as React from "react";

export function spanBreak(val: string | undefined): React.ReactNode {
    if (val === undefined) return undefined;
    return val.split("\n").map((s, i, a) => (
        <React.Fragment key={i}>
            <span>{s}</span>
            {i !== a.length - 1 && <br />}
        </React.Fragment>
    ));
}
